import { FormInstance } from "antd";
import type { ColumnsType } from "antd/es/table";

import { sortColumn } from "../../constants";
import { DrawerActionType } from "../../types";
import { Image, DateRange, Actions } from "../components/FormCells";
import { FeaturedEventsDataType } from "../types";

export function createColumns(
  form: FormInstance<any>,
  setOpenDrawer: (value: React.SetStateAction<boolean>) => void,
  setDrawerAction: (value: React.SetStateAction<DrawerActionType>) => void,
  refetch: any,
  hasKey?: boolean
): ColumnsType<FeaturedEventsDataType> {
  const keyColumn = hasKey ? [sortColumn] : [];

  return [
    ...keyColumn,
    {
      title: "Image",
      dataIndex: "imageUrl",
      render: (value: string) => <Image src={value} />,
    },
    {
      title: "Date range",
      dataIndex: "dateRange",
      render: (_, record: FeaturedEventsDataType) => (
        <DateRange startDate={record.publishDate} endDate={record.stopDate} />
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record: FeaturedEventsDataType) => (
        <Actions
          eventType="FeaturedEvent"
          record={record}
          form={form}
          setOpenDrawer={setOpenDrawer}
          setDrawerAction={setDrawerAction}
          refetch={refetch}
        />
      ),
    },
  ];
}
